(function () {
    'use strict';

    angular.module("imApp").factory("holidaysService", ['$ihttp', function ($ihttp) {
        let service = {
            listHolidays: function (parms) {
                return $ihttp.post({
                    method: 564,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
